import {useMemo} from 'react';
import {groupOrderDiscounts, AppliedDiscounts} from '@wix/ecom-platform-orders-commons/logic';
import {useLocaleKeys} from '../../LocaleKeysProvider';
import {useControllerProps} from '../ControllerContext';

export function useOrderDiscounts() {
  const lk = useLocaleKeys();
  const {appliedDiscounts: discounts} = useControllerProps().thankYouPageStore;

  return useMemo(
    () =>
      groupOrderDiscounts({
        appliedDiscounts: discounts as AppliedDiscounts,
        discountReasonLabels: {
          UNSPECIFIED: lk.thankYouPage.discounts.reason.unspecified(),
          EXCHANGED_ITEMS: lk.thankYouPage.discounts.reason.exchangedItems(),
          BILLING_ADJUSTMENT: lk.thankYouPage.discounts.reason.billingAdjustment(),
        },
      }),
    [discounts, lk]
  );
}
